import Swiper from "swiper/bundle";
import accordion from "./components/accordion";
import { sliderThumbs } from "./sustainability";

export default function solutionsJs() {
	var promoCardTitle = new Swiper(".promoCardTitle", {
		spaceBetween: 15,
		slidesPerView: 2,
		freeMode: true,
		watchSlidesProgress: true,
	});
	var promoCard = new Swiper(".promoCard", {
		autoHeight: false,
		slidesPerView: 1,
		effect: "fade",
		thumbs: {
			swiper: promoCardTitle,
		},
		on: {
			afterInit: function () {
				this.autoHeight = true;
			},
		},
	});

	// sliderThumbs(".promoCardTitle", promoCard);

	document.querySelectorAll('[data-js="accordion"]').forEach((elem) => {
		accordion(elem, true);
	});

	// var iconsNav = new Swiper(".iconsNav", {
	// 	spaceBetween: 15,
	// 	slidesPerView: 12,
	// 	freeMode: true,
	// 	watchSlidesProgress: true,
	// });
	const iconNavButtons = document.querySelectorAll(".iconNavButton");
	var cargoIconCards = new Swiper(".cargoIconCards", {
		autoHeight: false,
		slidesPerView: 1,
		effect: "fade",
	});

	iconNavButtons[cargoIconCards.activeIndex].classList.add("active");

	cargoIconCards.on("activeIndexChange", function () {
		document.querySelector(".iconNavButton.active").classList.remove("active");
		iconNavButtons[cargoIconCards.activeIndex].classList.add("active");
	});

	iconNavButtons.forEach((button, index) => {
		button.addEventListener("click", () => cargoIconCards.slideTo(index));
	});
}
